import styled from 'styled-components';
import { BREAKPOINTS, colors } from 'common/styles/style-constants';
import {
  OCButton,
  Span,
  FlexRow,
  Div,
} from 'common/styles/oc-styled-components';
import { Select } from 'opencare-crown';

export const SeeMoreReviewsButton = styled(OCButton)`
  && {
    background: ${colors.blue};
    color: ${colors.white};
    height: 100%;
    padding: 8px 15px;
    border-radius: 25px;
    align-self: center;

    &:hover,
    &:focus {
      color: ${colors.white} !important;
    }
  }
`;

export const ReviewsSelectWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
  padding-left: 40%;
  padding-right: 2.5%;

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

export const StyledSelect = styled(Select)`
  && {
    width: 100%;

    @media (max-width: ${BREAKPOINTS.mobileMax}px) {
      margin-left: 0;
    }

    && > .ant-select-dropdown-menu-item {
      font-weight: 400;
      color: purple;
    }
  }
`;

export const HappyToothContainer = styled(Span)`
  background: ${colors.blue};
  border-radius: 50%;
  padding: 20px;
`;

export const FlexContainer = styled(FlexRow)`
  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    flex-direction: column;
    margin-bottom: 50px;
  }
`;

export const ReviewContentContainer = styled(Div)`
  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    width: 100%;

    && > .rating-large {
      text-align: center;
    }
  }
`;

export const AggregateReviewContentContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
`;

export const AggregateReviewBreakdownContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    flex-direction: column;
    margin-bottom: 18px;
    align-items: flex-start;
  }
`;

export const AggregateReviewSelectContainer = styled.div`
  flex: 3;
  width: 100%;
  margin-right: 30px;

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    margin-right: 0;
    margin-bottom: 15px;
  }
`;

export const AggregateReviewDisclaimer = styled.small`
  font-size: 13px;
  line-height: 18px;
  flex: 2;
  color: ${colors.gray8};
`;

export const ReviewSourcesWrapper = styled.div`
  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    margin-top: 18px;
  }
`;

export const StyledProfileSubsection = styled.section`
  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    h1 {
      margin-bottom: 0;
    }
  }
`;

export const ReviewsList = styled.ul`
  list-style: none;
  padding: 0 10px;
  display: flex;
  flex-direction: column;
`;

export const ReviewBreakdownList = styled.ol`
  list-style: none;
  padding: 0px;
`;

export const ClinicReviewsSubRatingsFlexRow = styled(FlexRow)`
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
  row-gap: 20px;
  margin-bottom: 60px;

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    margin-bottom: 35px;
    padding-left: 10px;
    padding-right: 10px;
  }
`;
